import React, { Component } from "react";
import { connect } from "react-redux";

import { fetchAvailableGateways, deleteAvailableGateway } from "actions/availableGateway";
import { toggleconfirmationPopup, toggleNotification } from "actions/toggle";

import SearchForm from "./SearchForm";
import Table from "./Table";
import Pagination from "components/Pagination";

class AvailableGatewayIndex extends Component {
  componentDidMount() {
    this.props.fetchAvailableGateways();

    this.search = {};
  }

  fetchAvailableGatewaysWithSearchTerm() {
    const { AvailableGatewayURL: AvailableGateway_url } = this.props.match.params;
    this.props.fetchAvailableGateways({ AvailableGateway_url, ...this.search });
  }

  onSearchFormSubmit = data => {
    this.search = { [data.search_by]: data.search_term };
    this.fetchAvailableGatewaysWithSearchTerm();
  };

  onPaginationClick = page => event => {
    const { AvailableGatewayURL: AvailableGateway_url } = this.props.match.params;
    this.props.fetchAvailableGateways({ AvailableGateway_url, page, ...this.search });
  };

  handleAvailableGatewayDelete = id => event => {
    const { toggleconfirmationPopup } = this.props;
    toggleconfirmationPopup(true, {
      onClickDelete: () => {
        this.deleteAvailableGatewayProcess(id);
      },
      title: "Delete Payment Gateway",
      body: "Are you sure you want to delete this Payment Gateway?"
    });
  };

  deleteAvailableGatewayProcess(id) {
    const { toggleNotification, toggleconfirmationPopup, deleteAvailableGateway, match } = this.props;
    const { AvailableGatewayURL: AvailableGateway_url } = match.params;
    deleteAvailableGateway(id, { AvailableGateway_url })
      .then(() => {
        this.fetchAvailableGatewaysWithSearchTerm();
        toggleNotification(true, { infoClassName: "is-success", message: "Delete Payment Gateway Success" });
        toggleconfirmationPopup(false, {});
      })
      .catch(({ message }) => {
        toggleNotification(true, { infoClassName: "is-danger", message });
        toggleconfirmationPopup(false, {});
      });
  }

  render() {
    const { availableGateways } = this.props;

    return (
      <div>
        <div className="box">
          <SearchForm onSearchFormSubmit={this.onSearchFormSubmit} />
          <Table availableGateways={availableGateways} onClickDelete={this.handleAvailableGatewayDelete} />
          <Pagination
            onClick={this.onPaginationClick}
            currentPage={availableGateways.current_page}
            lastPage={availableGateways.last_page}
            range="4"
            modifyClasses="is-right"
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ authUser, availableGateways, confirmationPopupActive }) => ({
  authUser,
  availableGateways,
  confirmationPopupActive
});

export default connect(
  mapStateToProps,
  { fetchAvailableGateways, deleteAvailableGateway, toggleconfirmationPopup, toggleNotification }
)(AvailableGatewayIndex);



// WEBPACK FOOTER //
// ./src/pages/AvailableGateway/Index/index.js